module.exports = __webpack_public_path__ + "static/media/  (83).19828423.jpg";